<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Panel Depth';
                }
            },
            component_id: {
                default(){
                    return 'panel_depth';
                }
            },
        },
        computed: {
            thumbURL(){
                return '/images/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/panel-depth';
            },
            cache_key(){
              return '_';
            },
        },
        watch: {
          'cache_key': function (val, oldVal) {
            this.update_options();
          },
        }
    }
</script>
